const initialState = () => ({
  // { driver, isActive } | null mientras no se sabe
  sourceStatus: null,
  // Catálogo completo, en el orden global que manda el backend
  dashboards: [],
  // null | 'loading' | 'success' | 'error'
  dashboardsStatus: null,
  // Ficha del tablero con `organizations` (dónde se usa)
  currentDashboard: null,
  currentDashboardStatus: null,
  // Solo la respuesta de la última ficha de tablero pedida se aplica
  currentDashboardRequestId: 0,
  // Página actual del listado de organizaciones con Analytics
  organizations: [],
  // Mismo orden por default que el backend
  organizationsPagination: { page: 1, rowsPerPage: 25, rowsNumber: 0, sortBy: 'name', descending: false },
  organizationsStatus: null,
  // Solo la respuesta del último request del listado se aplica
  organizationsRequestId: 0,
  // Búsqueda y filtro del listado: se conservan al volver al hub
  organizationsSearch: '',
  organizationsStatusFilter: 'all',
  // { organizationsCount, activeOrganizationsCount, usersWithAccessCount, needsAttentionCount } | null
  organizationsSummary: null,
  organizationsSummaryStatus: null,
  // Ficha de la organización con `dashboards` y `orderMode`
  currentOrganization: null,
  currentOrganizationStatus: null,
  // Solo la respuesta de la última ficha pedida se aplica
  currentOrganizationRequestId: 0,
  // Página actual de la matriz de usuarios de una organización
  organizationUsers: [],
  organizationUsersPagination: { page: 1, rowsPerPage: 25, rowsNumber: 0, sortBy: 'name', descending: false },
  organizationUsersStatus: null,
  // De qué organización es la lista: al cambiarla se vacía
  organizationUsersOrganizationId: null,
  // Solo la respuesta del último request del listado se aplica
  organizationUsersRequestId: 0,
  // Los conteos de la ficha salen solo de la respuesta del guardado más reciente que sí se completó:
  // `userAccessWriteId` numera los enviados y `userAccessAppliedWriteId` es el último cuya respuesta se aplicó
  userAccessWriteId: 0,
  userAccessAppliedWriteId: 0
})

export default initialState
